import React, { useEffect, useState } from 'react';

import { BonusApi, useApplicationState, useSettings } from '@atlas/core';
import { EmptyStateView, Loader } from '@atlas/ui';

import FreeBetsTableItem from 'components/ClientProfile/Bonuses/FreeBets/FreeBetsTableItem';

import SeoPageText from '../../../SeoPage/SeoPageText';

const FreeBets = () => {
  const applicationState = useApplicationState();
  const { wallet: { currency } = {} } = applicationState;
  const { lang } = useSettings();

  const [freeBetsList, setFreeBetsList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { freeBets } = await BonusApi.getFreebetBonuses({
          country: 'test',
          currency,
          language: lang.toUpperCase(),
        });
        setFreeBetsList(freeBets);
      } finally {
        setIsLoading(false);
      }
    })();
  }, []);

  if (isLoading) {
    return <Loader className="relative" />;
  }

  if (freeBetsList.length === 0) {
    return (
      <>
        <EmptyStateView
          className="empty-center"
          description="account_freebet_bonuses_empty_description"
          title="account_freebet_bonuses_empty_title"
        />
        <SeoPageText />
      </>
    );
  }

  return (
    <div className="bonus-history-list">
      {freeBetsList.map(freeBet => (
        <FreeBetsTableItem freeBet={freeBet} key={freeBet.id} />
      ))}
      <SeoPageText />
    </div>
  );
};

export default FreeBets;
